import axios from 'axios'
var token = localStorage.token

// configure API
export const API = axios.create({
  baseURL: `https://restaurants.deliverlogic.com/rest_api/lightning/v1`,
  headers: {
    Authorization: 'Bearer ' + token
  }
})



// WEBPACK FOOTER //
// ./src/api.js